export default __webpack_public_path__ + "CircularCustCapNum-Light.d761f58dca52caefd60d16bf1a32d6ff.woff2";